import { ProductWithQuantity } from '../model';
import { GTMTrackCheckoutProps } from '../model/TrackingObject';

export type CheckoutEvent = {
    event: 'eec_checkout';
    ecommerce: {
        currencyCode?: string;
        checkout: {
            basket_id: string;
            actionField: {
                step: number;
                option?: string;
            };
            products: ProductWithQuantity[];
            total_price: string;
            total_quantity: string;
        };
    };
};

export const trackCheckoutEvent = ({
    currencyCode,
    step,
    shippingOption,
    basketId,
    products,
    totalPrice,
    totalQuantity,
}: GTMTrackCheckoutProps): CheckoutEvent => ({
    event: 'eec_checkout',
    ecommerce: {
        currencyCode,
        checkout: {
            basket_id: basketId,
            actionField: {
                step,
                option: shippingOption,
            },
            products,
            total_price: totalPrice,
            total_quantity: totalQuantity,
        },
    },
});
